export function hasBtn(btnName){
    var user = JSON.parse(sessionStorage.getItem('user'))||{};
    let btn = user.permissionList||[];
    if (btn.length==0){
        return false
    }else {
        return btn.indexOf(btnName) > -1;
    }
}
export function removeByIndex(arr,index) {
    for(var i=0; i<arr.length; i++) {
        if(i == index) {
            arr.splice(i, 1);
            break;
        }
    }
}
export function router_url(url,query) {
    var date = new Date().getTime();
    var query_obj={
        t:date
    };
    if (query) {
        query['t']=date;
    }else{
        query=query_obj
    }
    this.$router.push({
        path: url,
        query:query
    });
}
/*
    date:时间对象 时间字符串 时间数字
    format:y、M、d、h、H、m、s、q、S、a、A 分别表示年、月份、日期、小时（12 小时制）、小时（24 小时制）、分钟、秒、季度、毫秒、上午/下午、AM/PM。
*/
export function getDateTime(date,format){
    if(!date) date = new Date();
    if(String(date).length == 10) date = new Date(date * 1000);
    else if(String(date).length == 13) date = new Date(date);
    const o = {
        'M+': date.getMonth() + 1, // 月份
        'd+': date.getDate(), // 日
        'h+': date.getHours() % 12 === 0 ? 12 : date.getHours() % 12, // 小时
        'H+': date.getHours(), // 小时
        'm+': date.getMinutes(), // 分
        's+': date.getSeconds(), // 秒
        'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
        S: date.getMilliseconds(), // 毫秒
        a: date.getHours() < 12 ? '上午' : '下午', // 上午/下午
        A: date.getHours() < 12 ? 'AM' : 'PM', // AM/PM
    };
    if (/(y+)/.test(format)) {
        format = format.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
    for (let k in o) {
        if (new RegExp('(' + k + ')').test(format)) {
            format = format.replace(
                RegExp.$1,
                RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
            );
        }
    }
    return format;
}
export function getTime(/** timestamp=0 **/) {  
    var ts = arguments[0] || 0;  
    var t,y,m,d,h,i,s;  
    t = ts ? new Date(ts*1000) : new Date();
    // t = getDate(parseInt(ts*1000));
    y = t.getFullYear();    //年
    m = t.getMonth()+1;    // 月
    d = t.getDate();    //日
    h = t.getHours();    //时
    i = t.getMinutes();    //分
    s = t.getSeconds();   //秒
    // 可根据需要在这里定义时间格式  
    if (arguments[1]=='y') {
        return y+'-'+(m<10?'0'+m:m)+'-'+(d<10?'0'+d:d);
    }else if(arguments[1]=='m'){
        return (m<10?'0'+m:m)+'-'+(d<10?'0'+d:d);
    }else if(arguments[1]=='d'){
        return (d<10?'0'+d:d); 
    }else if(arguments[1]=='yyyy'){
        return y
    }else{
        return y+'-'+(m<10?'0'+m:m)+'-'+(d<10?'0'+d:d)+' '+(h<10?'0'+h:h)+':'+(i<10?'0'+i:i)+':'+(s<10?'0'+s:s);  
    }
}
const aRouter = []
export const formatRoutes = (aMenu) => {
    aMenu.forEach(oMenu => {
        const {path, title, icon, children,component,status } = oMenu
        if(children&&children.length>0){
            formatRoutes(children);
        }
        if(path&&status){
            const oRouter = {
                path:path,
                name:title+path,
                icon: icon,
                component:loadView(component),
            }
            aRouter.push(oRouter)
        }
    })
    return aRouter
}
export const loadView = (view) => {
  return resolve => require([`@/views/${view}`], resolve).catch(err => {
  })
}

// export function transListDataToTreeData(list, root){
//     const arr = []
//     // 1.遍历
//     list.forEach((item) => {
//         // 2.首次传入空字符串  判断list的pid是否为空 如果为空就是一级节点
//         if (item.pid === root) {
//             // 找到之后就要去找item下面有没有子节点  以 item.id 作为 父 id, 接着往下找
//             const children = transListDataToTreeData(list, item.id)
//             if (children.length > 0) {
//                 // 如果children的长度大于0,说明找到了子节点
//                 item.children = children
//             }
//             // 将item项, 追加到arr数组中
//             var obj={
//                 ...item,
//                 label:item.name||item.title
//             }
//             arr.push(obj)
//         }
//     })
//     return arr
// }
export function convertToTreeData(list, id = null, linkId = 'id', parentId = 'pid') {
    const map = new Map();
    list.forEach(item => {
        item.label=item.name||item.title;
        map.set(item[linkId], item);
    });
    const treeData = [];
    list.forEach(item => {
        const parent = map.get(item[parentId]);
        if (parent) {
            if(!parent.children){
                parent['children'] = [item];
            }else{
                parent.children.push(item);
            }
        } else {
            treeData.push(item);
        }
    });
    return treeData;
}
export function array_object(list){
    var arr={};
    for (var i = 0; i < list.length; i++) {
        arr[list[i].code] = list[i].name;
    }
    return arr
}

export function generateSku(specs){
    const specValues = specs.filter(spec=>spec.valueList.length>0).map(spec => {
        return spec.valueList.map((ite)=>{return {...ite, name:spec.name,name_en:spec.name_en}});
    });
    const cartesian = (...arrays) => arrays.reduce((a, b) =>a.flatMap(x => b.map(y => [...x, y])),[[]]).filter(arr => arr.length > 0);
    const allCombinations = cartesian(...specValues);
    return allCombinations.map((combo, index) => ({
        id:'',
        specs:combo.reduce((acc, item) => {
            acc[item.name] = item.value;
            return acc;
        }, {}),
        specs_snapshot:combo.reduce((acc, item) => {
            acc[item.name_en+'_id'] = item.id;
            return acc;
        }, {}),
        price:'',
        market_price:'',
        sku_code:'',
        barcode:'',
        weight:'',
        volume:'',
        unit:'',
        sort:'',
    }));
};


// WEBPACK FOOTER //
// ./src/utils/index.js